var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { ErrorOutline as IconErrorOutline, Info as IconInfo, Warning as IconWarning, } from "@mui/icons-material";
import { useMemo } from "react";
import { useStyles } from "./ui_icon_standard.css";
export const UiIconStandard = (_a) => {
    var { variant } = _a, props = __rest(_a, ["variant"]);
    const classes = useStyles({ variant });
    return useMemo(() => {
        switch (variant) {
            case "error":
                return (_jsx(IconErrorOutline, Object.assign({ className: classes.ui_icon_standard }, props)));
            case "info":
                return _jsx(IconInfo, Object.assign({ className: classes.ui_icon_standard }, props));
            case "warning":
                return _jsx(IconWarning, Object.assign({ className: classes.ui_icon_standard }, props));
        }
    }, [classes.ui_icon_standard, props, variant]);
};
//# sourceMappingURL=ui_icon_standard.js.map